'use client'

import { type FC } from 'react'

import { ErxHub } from '../../erx-hub'
import { NfcLandingPageSeoHeadTags } from '../seo/components/NfcLandingPageSeoHeadTags'

import { NfcLandingPageBenefitsSection } from './NfcLandingPageBenefitsSection/NfcLandingPageBenefitsSection'
import { NfcLandingPageCardSection } from './NfcLandingPageCardSection/NfcLandingPageCardSection'
import { NfcLandingPageFamilyPrescriptionSection } from './NfcLandingPageFamilyPrescriptionSection/NfcLandingPageFamilyPrescriptionSection'
import { NfcLandingPageFaq } from './NfcLandingPageFaq/NfcLandingPageFaq'
import { NfcLandingPageHeroHeader } from './NfcLandingPageHeroHeader/NfcLandingPageHeroHeader'
import { NfcLandingPageHowItWorksSection } from './NfcLandingPageHowItWorksSection/NfcLandingPageHowItWorksSection'
import { NfcLandingPageStepByStep } from './NfcLandingPageStepByStep'

export const NfcLandingPage: FC = () => {
  return (
    <>
      <NfcLandingPageSeoHeadTags />
      <div
        className="flex flex-col gap-12 bg-light-primary-medium pb-4 tablet:gap-0 tablet:py-0"
        data-qa-id="erx-nfc-lp-content"
      >
        <NfcLandingPageHeroHeader />
        <NfcLandingPageHowItWorksSection />
        <NfcLandingPageStepByStep />
        <NfcLandingPageFamilyPrescriptionSection />
        <NfcLandingPageCardSection />
        <NfcLandingPageBenefitsSection />
      </div>

      <NfcLandingPageFaq />
      <ErxHub />
    </>
  )
}
